import { z } from 'zod'

export const STRATALYST_REPORT_UPLOAD_DELETE_CONTRACT_VERSION = '1.0.0' as const

export const stratalystReportUploadDeleteResponseSchema = z.object({
  contract_version: z.string().min(1),
}).passthrough()

export type StratalystReportUploadDeleteResponse = z.infer<typeof stratalystReportUploadDeleteResponseSchema>
